<template>
<div class="home">
	<div class="home-header">
		<!-- swiper -->
		<swiper :options="swiperOption">
			<swiper-slide @click.native="toUrl">
				<img width="100%" src="https://static.qyjmed.com/webSite/index/banner.png" alt="">
			</swiper-slide>
			<!-- <swiper-slide>
				<img width="100%" src="https://static.qyjmed.com/webSite/index/banner2.png" alt="">
			</swiper-slide> -->
			<div class="swiper-pagination" slot="pagination"></div>
		</swiper>
		<!-- banner下list -->
		<div class="cloud-server">
			<div @click="toYunServer" @mouseenter="showActive(1)" @mouseleave="showActive(0)" class="card">
				<div class="card-inner">
					<div class="card-icon">
						<img v-if="active==1" src="https://static.qyjmed.com/webSite/index/server-cloud-white.png" alt="">
						<img v-else src="https://static.qyjmed.com/webSite/index/server-cloud.png" alt="">
					</div>
					<div class="card-content">
						<h2>云服务平台</h2>
						<p>实现海量信息完美整合，颠覆性开创全产业链一站式服务</p>
					</div>
				</div>
			</div>
			<div @click="toServerManage" @mouseenter="showActive(2)" @mouseleave="showActive(0)" class="card">
				<div class="card-inner">
					<div class="card-icon">
						<img v-if="active==2" src="https://static.qyjmed.com/webSite/index/serve-small-white.png" alt="">
						<img v-else src="https://static.qyjmed.com/webSite/index/serve-small.png" alt="">
					</div>
					<div class="card-content">
						<h2>设备管理软件</h2>
						<p>集设备资产管理、质量控制、效益分析、实时监控为一体的医院设备全生命周期智能化管理软件</p>
					</div>
				</div>
			</div>
			<div @click="toMainterance" @mouseenter="showActive(3)" @mouseleave="showActive(0)" class="card">
				<div class="card-inner">
					<div class="card-icon">
						<img v-if="active==3" src="https://static.qyjmed.com/webSite/index/weibao-white.png" alt="">
						<img v-else src="https://static.qyjmed.com/webSite/index/weibao.png" alt="">
					</div>
					<div class="card-content">
						<h2>维保服务</h2>
						<p>提供规范化，标准化的国内外各品牌全线医疗设备的维修、保修、托管服务</p>
					</div>
				</div>
			</div>
			<!-- <div @click="toSupplyChain" @mouseenter="showActive(4)" @mouseleave="showActive(0)" class="card"> -->
			<div @mouseenter="showActive(4)" @mouseleave="showActive(0)" class="card">
				<div class="card-inner">
					<div class="card-icon">
						<img v-if="active==4" src="https://static.qyjmed.com/webSite/index/gongyin-white.png" alt="">
						<img v-else src="https://static.qyjmed.com/webSite/index/gongyin.png" alt="">
					</div>
					<div class="card-content">
						<h2>技术支持</h2>
						<p>随时解答您使用中的问题，快速处理任何故障，最快2小时内响应，让您后顾无忧。</p>
						<!-- <h2>供应链金融</h2>
                        <p>整合上下游企业，提供应收、存货、预付及租赁等全产业链服务</p> -->
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- 云服务平台 -->
	<div id="yunServer" class="yun-server container">
		<h2>云服务平台</h2>
		<img data-wow-delay="0.5s" class="wow bounceInDown" src="https://static.qyjmed.com/webSite/index/yun-server.png" alt="">
		<div class="content ">
			<div data-wow-delay="1s" class="list wow bounceInLeft">
				<div class="list-icon">
					<img src="https://static.qyjmed.com/webSite/index/yun1.png" alt="">
				</div>
				<div class="list-text">
					<p>近1000多家合作医院</p>
					<p>为超过1000家合作医院提供设备维修管理服务</p>
				</div>
			</div>
			<div data-wow-delay="1s" class="list wow bounceInLeft">
				<div class="list-icon">
					<img src="https://static.qyjmed.com/webSite/index/yun2.png" alt="">
				</div>
				<div class="list-text">
					<p>3000多家服务商</p>
					<p>与超过3000家服务供应商结为战略合作伙伴，提供放心快捷的售后服务</p>
				</div>
			</div>
			<div data-wow-delay="1s" class="list wow bounceInRight">
				<div class="list-icon">
					<img src="https://static.qyjmed.com/webSite/index/yun3.png" alt="">
				</div>
				<div class="list-text">
					<p>近10000名工程师</p>
					<p>为超过1000家合作医院提供设备维修管理服务</p>
				</div>
			</div>
			<div data-wow-delay="1s" class="list wow bounceInRight">
				<div class="list-icon">
					<img src="https://static.qyjmed.com/webSite/index/yun4.png" alt="">
				</div>
				<div class="list-text">
					<p>各省级医疗检测机构</p>
					<p>与全国30家设备质量检测机构深度合作，提供设备质量检测服务</p>
				</div>
			</div>
		</div>
	</div>
	<!-- 设备管理软件 -->
	<div id="serverManage" class="server-manage">
		<div class="container">
			<h2>设备管理软件</h2>
			<img src="https://static.qyjmed.com/webSite/index/line.png" alt="">
			<p>Device management software</p>
			<ul>
				<li data-wow-delay="1s" class="list wow bounceInLeft">
					<div class="device-manage">
						<div class="device-img">
							<img src="https://static.qyjmed.com/webSite/index/manage1.png" alt="">
						</div>
						<div class="device-product">
							<p>实时监控</p>
							<p>第一时间了解医院大型设备状况、查看中小型设备使用率</p>
						</div>
					</div>
				</li>
				<li data-wow-delay="1s" class="list wow bounceInRight">
					<div class="device-manage">
						<div class="device-img">
							<img src="https://static.qyjmed.com/webSite/index/manage2.png" alt="">
						</div>
						<div class="device-product">
							<p>资产管理</p>
							<p>医院固定资产全生命周期管理，查看设备的档案记录</p>
						</div>
					</div>
				</li>
				<li data-wow-delay="1s" class="list wow bounceInLeft">
					<div class="device-manage">
						<div class="device-img">
							<img src="https://static.qyjmed.com/webSite/index/manage3.png" alt="">
						</div>
						<div class="device-product">
							<p>耗材管理</p>
							<p>高低值耗材的出入库管理，自动库存购买、供应商资质到期提醒</p>
						</div>
					</div>
				</li>
				<li data-wow-delay="1s" class="list wow bounceInRight">
					<div class="device-manage">
						<div class="device-img">
							<img src="https://static.qyjmed.com/webSite/index/manage4.png" alt="">
						</div>
						<div class="device-product">
							<p>保养管理</p>
							<p>为医院重要设备建立保养机制、定期保养巡检，记录工程师工作量</p>
						</div>
					</div>
				</li>
				<li data-wow-delay="1s" class="list wow bounceInLeft">
					<div class="device-manage">
						<div class="device-img">
							<img src="https://static.qyjmed.com/webSite/index/manage5.png" alt="">
						</div>
						<div class="device-product">
							<p>效益分析</p>
							<p>定制化展示医院设备经营状况，为医院采购提供决策支持</p>
						</div>
					</div>
				</li>
				<li data-wow-delay="1s" class="list wow bounceInRight">
					<div class="device-manage">
						<div class="device-img">
							<img src="https://static.qyjmed.com/webSite/index/manage6.png" alt="">
						</div>
						<div class="device-product">
							<p>质量控制</p>
							<p>定期对医院的重要设备进行计量管理，对医院的不良事件进行监测，保证设备健康状态</p>
						</div>
					</div>
				</li>
				<li data-wow-delay="1s" class="list wow bounceInLeft">
					<div class="device-manage">
						<div class="device-img">
							<img src="https://static.qyjmed.com/webSite/index/manage7.png" alt="">
						</div>
						<div class="device-product">
							<p>工作提醒</p>
							<p>保养提醒、库存预警提醒、计量到期提醒、资产折旧提醒免去医院设备管理中的后顾之忧</p>
						</div>
					</div>
				</li>
				<li data-wow-delay="1s" class="list wow bounceInRight">
					<div class="device-manage">
						<div class="device-img">
							<img src="https://static.qyjmed.com/webSite/index/manage8.png" alt="">
						</div>
						<div class="device-product">
							<p>工作流程</p>
							<p>单一的工作流程入口，方便快捷的对医院设备进行统一操作</p>
						</div>
					</div>
				</li>
			</ul>
			<button type="button" @click="toSoft()" name="button">了解更多 | MORE..</button>
		</div>
	</div>
	<!-- 维保服务 -->
	<div id="mainterance" class="maintenance container">
		<h2>维保服务</h2>
		<img src="https://static.qyjmed.com/webSite/index/line-light.png" alt="">
		<p>Maintenance service</p>
		<div class="service-main">
			<div class="maintenance-card">
				<img src="https://static.qyjmed.com/webSite/index/maintenance1.png" alt="">
				<div class="card-content">
					<p>
						<img src="https://static.qyjmed.com/webSite/index/main-icon1.png" alt="">
						<span>维修</span>
					</p>
					<p>为医院权限设备提供快速优质的维修、升级、移机服务</p>
					<p>专业，快捷</p>
				</div>
			</div>
			<div class="maintenance-card">
				<img src="https://static.qyjmed.com/webSite/index/maintenance2.png" alt="">
				<div class="card-content">
					<p>
						<img src="https://static.qyjmed.com/webSite/index/main-icon2.png" alt="">
						<span>买保</span>
					</p>
					<p>确保医院大型设备安全运行，延长使用寿命</p>
					<p>经济，周到</p>
				</div>
			</div>
			<div class="maintenance-card">
				<img src="https://static.qyjmed.com/webSite/index/maintenance3.png" alt="">
				<div class="card-content">
					<p>
						<img src="https://static.qyjmed.com/webSite/index/main-icon3.png" alt="">
						<span>全院托管</span>
					</p>
					<p>提供影像科全院医疗设备全托管服务，为医院设备安全运行保驾护航</p>
					<p>全面，安全</p>
				</div>
			</div>
		</div>
		<button @click="toMain()" type="button" name="button">了解更多 | MORE..</button>
	</div>
	<!-- 供应链金融 -->
	<!-- <div id="supplyChain" class="supply-chain container">
        <h2>供应链金融</h2>
        <img src="https://static.qyjmed.com/webSite/index/line-light.png" alt="">
        <p>Supply chain finance</p>
        <div class="supply">
            <div @mouseenter="showActive(5)" @mouseleave="showActive(0)" class="supply-box">
                <img v-if="active==5" src="https://static.qyjmed.com/webSite/index/supply1-1.png" alt="">
                <img v-else src="https://static.qyjmed.com/webSite/index/supply1.png" alt="">
                <p>存货融资</p>
                <p>医疗公司资金周转有压力，全医佳有正品行货库存积压，愿与您共享资源</p>
            </div>
            <div @mouseenter="showActive(6)" @mouseleave="showActive(0)" class="supply-box">
                <img v-if="active==6" src="https://static.qyjmed.com/webSite/index/supply2-1.png" alt="">
                <img v-else src="https://static.qyjmed.com/webSite/index/supply2.png" alt="">
                <p>融资租赁</p>
                <p>为医院、供应商提供金融服务，减轻您的经济压力</p>
            </div>
            <div @mouseenter="showActive(7)" @mouseleave="showActive(0)" class="supply-box">
                <img v-if="active==7" src="https://static.qyjmed.com/webSite/index/supply3-1.png" alt="">
                <img v-else src="https://static.qyjmed.com/webSite/index/supply3.png" alt="">
                <p>购买垫资或过程垫资</p>
                <p>单一或招标系列产品购买时，全医佳为您提供供应链产品打包服务和资金垫付服务</p>
            </div>
            <div @mouseenter="showActive(8)" @mouseleave="showActive(0)" class="supply-box">
                <img v-if="active==8" src="https://static.qyjmed.com/webSite/index/supply4-1.png" alt="">
                <img v-else src="https://static.qyjmed.com/webSite/index/supply4.png" alt="">
                <p>供应链产品服务</p>
                <p>全医佳为您提供优势的产品价格和正品行货服务</p>
            </div>
        </div>
        <button @click="toSupply()" type="button" name="button">了解更多 | MORE..</button>
    </div> -->
	<!-- 公司新闻 -->
	<div id="company" class="company-new">
		<div class="container">
			<h2>公司新闻</h2>
			<img src="https://static.qyjmed.com/webSite/index/line.png" alt="">
			<p>Company news</p>
			<div class="news-swiper">
				<!-- swiper -->
				<swiper :options="newsSwiperOption" ref="mySwiper">
					<swiper-slide>
						<div class="swiper-content" @click="toDetail(1)">
							<div class="swiper-img">
								<img width="100%" src="https://static.qyjmed.com/webSite/news/company/1-1.jpg" alt="">
							</div>
							<div class="swiper-box">
								<p>全医佳与彩超服务联盟缔结战略合作 共同打造医疗设备售后服务平台</p>
								<p>2017-01-09</p>
								<p>2017年1月9日江苏全医佳电子商务有限公司携手“彩超技术服务联盟”，在南京紫东国际创意园正式签约，双方成立全医佳彩超合作联盟，有效实现资源信息互补、共享，提高双方的市场竞争力。</p>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="swiper-content" @click="toDetail(2)">
							<div class="swiper-img">
								<img width="100%" src="https://static.qyjmed.com/webSite/news/company/2.jpg" alt="">
							</div>
							<div class="swiper-box">
								<p>北京健康扶贫基金会与全医佳达成战略合作伙伴</p>
								<p>2016-12-01</p>
								<p>2016年12月1日，江苏全医佳电子商务有限公司副总经理谢玉丹来我会签订一站式医疗设备服务平台项目合作协议书，我会执行理事长朱定良、调研部主任秦燕参与了此次合作协议签订会。</p>
							</div>
						</div>
					</swiper-slide>
					<swiper-slide>
						<div class="swiper-content" @click="toDetail(3)">
							<div class="swiper-img">
								<img width="100%" src="https://static.qyjmed.com/webSite/news/company/3-1.jpg" alt="">
							</div>
							<div class="swiper-box">
								<p>互联网+医疗设备质量控制和管理高峰论坛</p>
								<p>2016-06-26</p>
								<p>为认真学习国家最新颁布的医疗器械质量管理的相关法律法规，深入探讨如何将医疗器械使用管理、质量控制及维修管理的各方面工作与互联网技术相结合，提升医疗设备管理效率及使用安全性，由中国医学装备协会及全医佳医疗设备服务平台联合举办的“互联网</p>
							</div>
						</div>
					</swiper-slide>
					<div class="swiper-button-prev" slot="button-prev"></div>
					<div class="swiper-button-next" slot="button-next"></div>
					<div class="swiper-pagination" slot="pagination"></div>
				</swiper>
			</div>
		</div>
	</div>
	<!-- 合作医院 -->
	<div class="teamwork container">
		<h2>合作医院</h2>
		<img src="https://static.qyjmed.com/webSite/index/line-light.png" alt="">
		<p>Cooperation in the hospital</p>
		<ul>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/1.png" alt="">
					<p>无锡市第二人民医院</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/2.png" alt="">
					<p>安徽医学装备质控中心</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/3.png" alt="">
					<p>江苏省中西医结合医院</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/4.png" alt="">
					<p>六安市人民医院</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/5.png" alt="">
					<p>芜湖第一人民医院</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/6.png" alt="">
					<p>温州市人民医院</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/7.png" alt="">
					<p>泰安市第一人民医院</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/8.png" alt="">
					<p>鄄城县人民医院</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/9.png" alt="">
					<p>芜湖市第一人民医院</p>
				</div>
			</li>
			<li>
				<div class="hospital-box">
					<img src="https://static.qyjmed.com/webSite/index/hospital/10.png" alt="">
					<p>新乡市中心医院</p>
				</div>
			</li>
		</ul>
	</div>
	<Foot></Foot>
</div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import 'swiper/dist/css/swiper.css'
import {
	swiper,
	swiperSlide
} from 'vue-awesome-swiper';
import Foot from '@/components/Footer.vue'
import {
	WOW
} from 'wowjs';
export default {
	name: 'home',
	data() {
		return {
			// 大banner
			swiperOption: {
				pagination: '.swiper-pagination',
				slidesPerView: 1,
				autoplay: 3000,
				loop: true,
				paginationClickable: true,
			},
			// 新闻banner
			newsSwiperOption: {
				pagination: '.swiper-pagination',
				slidesPerView: 1,
				autoplay: 3000,
				loop: true,
				paginationClickable: true,
				prevButton: '.swiper-button-prev',
				nextButton: '.swiper-button-next',
			},
			active: 0,
		}
	},
	methods: {
		toUrl: function() {
			// alert(123)
		},
		toDetail: function(index) {
			this.$router.push({
				path: './article' + index + ''
			})
		},
		toMain: function() {
			this.$router.push({
				path: '/maintenance'
			})
		},
		toSupply: function() {
			this.$router.push({
				path: '/supply'
			})
		},
		toSoft: function() {
			this.$router.push({
				path: '/software'
			})
		},
		toYunServer: function() {
			console.log(this.GLobal.a)
			console.log(234)
			document.querySelector("#yunServer").scrollIntoView(true);
			// let topHeight =document.querySelector(".yun-server").offsetTop;
			// this.$options.methods.toScroll(topHeight)
		},
		toServerManage: function() {
			document.querySelector("#serverManage").scrollIntoView(true);
			// let topHeight =document.querySelector("#serverManage").offsetTop;
			// this.$options.methods.toScroll(topHeight)
		},
		toMainterance: function() {
			document.querySelector("#mainterance").scrollIntoView(true);
			// let topHeight =document.querySelector("#mainterance").offsetTop;
			// this.$options.methods.toScroll(topHeight)
		},
		toSupplyChain: function() {
			document.querySelector("#supplyChain").scrollIntoView(true);
			// let topHeight =document.querySelector("#supplyChain").offsetTop;
			// this.$options.methods.toScroll(topHeight)
		},
		showActive: function(index) {
			this.active = index;
		},
		toScroll: function(index) {
			let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
			// 用 class="scroll_title" 添加锚点
			let scroll_content = document.querySelector(".yun-server")
			let total = index; //这是头部header的高度
			let distance = scroll_content.offsetTop; //获取需要滚动的距离
			distance = distance - total;
			// 平滑滚动，时长500ms，每10ms一跳，共50跳
			console.log(total)
			let step = total / 50
			if (total > distance) {
				smoothDown()
			} else {
				let newTotal = distance - total
				step = newTotal / 50
				smoothUp()
			}

			function smoothDown() {
				if (distance < total) {
					distance += step
					// console.log(123)
					// 　　　　　　　scroll_content.scrollTop = distance
					window.scroll(700, distance);
					setTimeout(smoothDown, 10)
				} else {
					scroll_content.scrollTop = total
				}
			}

			function smoothUp() {
				if (distance > total) {
					distance -= step
					scroll_content.scrollTop = distance
					setTimeout(smoothUp, 10)
				} else {
					scroll_content.scrollTop = total
				}
			}
		},


	},
	computed: {

	},
	mounted() {
		var wow = new WOW({
			live: false
		})
		wow.init()
	},
	components: {
		swiper,
		swiperSlide,
		Foot
	}
}
</script>
<style scoped lang="scss">
.home {
    margin-top: $highlight-height;
    .home-header {
        .cloud-server {
            padding: 30px 6%;
            height: 180px;
            background: #F6F8FA;
            .card {
                width: 23%;
                height: 180px;
                margin: 0 1%;
                background: white;
                display: inline-block;
                vertical-align: top;
                .card-inner {
                    padding: 42px 10% 0;
                    .card-icon {
                        display: inline-block;
                        width: 20%;
                        vertical-align: top;
                        margin-top: 8px;
                    }
                    .card-content {
                        width: 80%;
                        display: inline-block;
                        h2 {
                            font-weight: 400;
                            font-size: 24px;
                            color: #3D81E5;
                        }
                        p {
                            color: #000;
                            line-height: 20px;
                            line-height: 26px;
                            margin-top: 6px;
                        }
                    }
                }
                &:hover {
                    background: #9DCCFF;
                    cursor: pointer;
                    // animation: shake 2s;
                    background-position: 0 0;
                    h2,
                    p {
                        color: white !important;
                    }
                    img {
                        // transform: rotate(360deg);
                        // transition: 1s;
                        animation: bounceInLeft 1s;
                    }

                }
            }
        }
    }
    // 云服务平台
    .yun-server {
        text-align: center;
        h2 {
            padding: 60px;
            font-weight: 400;
            font-size: 32px;
            color: #4C4C4E;
        }
        .content {
            margin-bottom: 70px;
            .list {
                display: inline-block;
                width: 50%;
                margin-top: 60px;
                .list-icon {
                    width: 20%;
                    display: inline-block;
                    vertical-align: top;
                }
                .list-text {
                    width: 80%;
                    display: inline-block;
                    text-align: left;
                    p:first-child {
                        font-size: 18px;
                        margin-bottom: 20px;
                        font-weight: bold;
                    }
                    p:last-child {
                        font-size: 14px;
                    }
                }
            }
        }
    }
    // 设备管理软件
    .server-manage {
        background: url("https://static.qyjmed.com/webSite/index/server-device.png") no-repeat center;
        height: 838px;
        .container {
            @include title;
            h2 {
                padding-top: 6 0;
            }
            ul {
                padding: 40px 50px 50px;
                li {
                    width: 50%;
                    display: inline-block;
                    vertical-align: top;
                    .device-manage {
                        padding: 18px 20px;
                        .device-img {
                            width: 20%;
                            display: inline-block;
                            vertical-align: top;
                        }
                        .device-product {
                            width: 60%;
                            display: inline-block;
                            text-align: left;
                            font-size: 22px;
                            color: white;
                            font-weight: 100;
                            vertical-align: top;
                            p:first-child {
                                margin-bottom: 6px;
                            }
                            p:last-child {
                                font-size: 14px;
                                line-height: 22px;
                                letter-spacing: 1px;

                            }
                        }
                    }
                }
            }
            button {
                @include button;
            }
        }
    }
    // 维保服务
    .maintenance {
        button {
            @include button;
        }
        @include title-light;
        .service-main {
            padding: 50px 0;
            .maintenance-card {
                display: inline-block;
                width: 370px;
                padding: 13px;
                .card-content {
                    padding: 0 30px;
                    border:1px solid #E5E5E5 {
                        top: 0;
                        bottom-left-radius: 6px;
                        bottom-right-radius: 6px;
                    }
                    height: 270px;
                    margin-top: -4px;
                    text-align: left;
                    p {
                        font-size: 20px;
                        color: #262626;
                    }
                    p:nth-child(1) {
                        padding: 20px 0;
                        span {
                            display: inline-block;
                            vertical-align: top;
                            margin: 14px 0 0 20px;
                        }
                    }
                    p:nth-child(2) {
                        line-height: 30px;
                        margin-bottom: 20px;
                    }
                    p:nth-child(3) {
                        font-size: 16px;
                        color: #FF9920;
                    }
                }
            }
        }
    }
    // 供应链金融
    .supply-chain {
        @include title-light;
        .supply {
            margin: 60px 0 70px;
            .supply-box {
                width: 270px;
                height: 330px;
                display: inline-block;
                border: 1px solid #E5E5E5;
                border-radius: 6px;
                vertical-align: top;
                margin: 0 14px;
                img {
                    margin: 40px 0;
                }
                p {
                    margin-bottom: 20px;
                    font-size: 24px;
                    color: #262626;
                    padding: 0 30px;
                }
                p:last-child {
                    font-size: 14px;
                    color: #6A6A6A;
                    text-align: left;
                }
                &:hover {
                    border: 1px solid #3B96FE;
                    p {
                        color: #3B96FE;
                    }
                }
            }
        }
        button {
            @include button;
            margin-bottom: 80px;
        }
    }
    // 公司新闻
    .company-new {
        background: url("https://static.qyjmed.com/webSite/index/newbg.png") center;
        height: 680px;
        margin-top: 40px;
        .container {
            @include title;
            > h2 {
                font-size: 30px;
            }
            > p {
                letter-spacing: 10px;
            }
            .news-swiper {
                position: relative;
                padding: 0 125px;
                .swiper-container {
                    position: unset;
                    .swiper-wrapper {
                        .swiper-slide {
                            .swiper-content {
                                cursor: pointer;
                                width: 830px;
                                height: 150px;
                                background: white;
                                margin: 50px 0 40px;
                                padding: 50px 60px 100px;
                                .swiper-img {
                                    width: 150px;
                                    height: 150px;
                                    display: inline-block;
                                    > img {
                                        width: 150px;
                                        height: 150px;
                                    }
                                }
                                .swiper-box {
                                    width: 620px;
                                    display: inline-block;
                                    margin-left: 30px;
                                    vertical-align: top;
                                    p {
                                        text-align: left;
                                        font-size: 18px;
                                    }
                                    > p:first-child {
                                        font-weight: bold;
                                    }
                                    > p:nth-child(2) {
                                        font-size: 14px;
                                        color: #75A0C9;
                                        margin: 10px 0 20px;
                                    }
                                    > p:last-child {
                                        line-height: 28px;
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-box-orient: vertical;
                                        -webkit-line-clamp: 3;
                                    }
                                }
                            }
                        }
                    }
                    .swiper-pagination-bullets {
                        bottom: 75px;
                    }
                    .swiper-button-next,
                    .swiper-button-prev {
                        background-image: url("https://static.qyjmed.com/webSite/index/prev.png");
                        top: 36%;
                        width: 65px;
                        height: 120px;
                        background-size: 80%;
                    }
                    .swiper-button-next {
                        background-image: url("https://static.qyjmed.com/webSite/index/next.png");
                    }
                }
            }
        }
    }
    // 合作医院
    .teamwork {
        @include title-light;
        ul {
            li {
                display: inline-block;
                width: 200px;
                margin: 50px 20px;
                div {
                    color: #6A6A6A;
                    cursor: pointer;
                    p {
                        margin-top: 20px;
                    }
                    &:hover {
                        img {
                            transform: rotate(360deg);
                            transition: 1s;
                        }
                    }
                }
            }
        }
    }

}
</style>
